import CreatePassword from "../components/createPassword/CreatePassword";

export default function CreatePasswordPage() {
  return <CreatePassword />;
}
